<div class="card" [class.payment]="currentStep === 2">
  <div class="card-body" *ngIf="portalProducts">
    <div class="row">
      <div class="col-lg-12 position-relative">
        <!--Membership Options-->
        <ng-container *ngIf="currentStep == 0 && !membershipModalVisible">
          <div class="h-100">
            <div class="personal-details-panel position-relative">
              <div class="h-100">
                <h4 class="font-size-20 mb-3">{{ 'kids.membership.upgrade.title' | translate }}</h4>
                <p class="font-size-12" [innerHTML]="'kids.membership.upgrade.description' | translate | markdownTranslate"></p>

                <div class="child-names-section mb-2">
                  <hr class="my-1 bg-muted" />
                  <div *ngFor="let child of childUpgrades; let i = index">
                    <div class="py-2">
                      <h5 class="text-primary font-size-20">{{ 'child.upgrade.detail.title' | translate }} {{ i + 1 }}</h5>
                      <div class="w-100 d-flex flex-lg-row flex-column justify-content-lg-between align-items-lg-center">
                        <div class="d-flex align-items-center">
                          <label class="mb-0 child-name me-2 text-primary">{{ child.FirstName + ' ' + child.LastName }}</label>
                          <p class="mb-0">{{ child.DateOfBirth | date }}</p>
                        </div>
                        <ng-container *ngIf="child.Product.ProductId == 0 || !child.Product.ProductId">
                          <div class="d-lg-none d-flex">
                            <button
                              (click)="showMembershipModal(child)"
                              class="btn btn-primary fw-bold border-0 text-white w-100 mt-lg-0 mt-1"
                            >
                              {{ 'upgrade.children.choose.membership' | translate }}
                            </button>
                          </div>
                          <div class="d-lg-flex d-none">
                            <button (click)="showMembershipModal(child)" class="btn fw-bold border-0 btn-primary">
                              {{ 'upgrade.children.choose.membership' | translate }}
                            </button>
                          </div>
                        </ng-container>
                      </div>
                      <div
                        class="upgrade-membership-container d-lg-flex justify-content-between align-items-center"
                        *ngIf="child.Product.ProductId != 0"
                      >
                        <div>
                          <div class="fw-bold font-size-14">
                            {{ child.Product.DisplayName }}
                          </div>
                          <div class="font-size-12 mt-2">
                            <span class="fw-bold">{{ 'membership.chosen.price' | translate }}</span>
                            {{ child.Product.MerchantPrice / 100 | FortressCurrencyPipe }}
                          </div>
                        </div>
                        <button
                          (click)="showMembershipModal(child)"
                          class="btn fw-bold border-0 text-primary change-btn mt-lg-0 mt-3 w-lg-auto w-100"
                        >
                          {{ 'upgrade.children.change.membership' | translate }}
                        </button>
                      </div>
                    </div>
                    <hr class="my-1 bg-muted" />
                  </div>
                </div>
              </div>
              <div class="button-container d-flex justify-content-end">
                <!-- Previous Button -->
                <button (click)="CloseModal()" class="btn border-0 nav-button text-error fw-bold mb-0">
                  {{ 'child.upgrade.options.back.button' | translate }}
                </button>
                <!-- Next Button -->
                <button (click)="showNext(1)" class="btn btn-success nav-button fw-bold mb-0" *ngIf="!noMembershipsSelected">
                  {{ 'child.upgrade.options.next.button' | translate }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!--Membership selection-->
        <ng-container *ngIf="membershipModalVisible">
          <div class="border-bottom pb-2 mb-2 d-flex justify-content-between">
            <div>
              <h4 class="font-size-20 mb-2">
                {{ 'membership.options.title' | translate }}
              </h4>
              <span class="font-size-12" [innerHTML]="'membership.description.title' | translate | markdownTranslate"> </span>
            </div>
            <span class="icon material-icons cancel cursor-pointer text-grey" aria-hidden="true" (click)="closeMembershipModal()"
              >close_small</span
            >
          </div>
          <div class="row">
            <div *ngFor="let product of portalProducts" class="col-lg-6 col-12 my-2">
              <div class="membership-container p-3">
                <img
                  class="membership-image mx-auto d-block"
                  src="{{ product.PortalProduct.PrimaryImage | contentImage : '23' }}"
                  alt="{{ product.PortalProduct.PrimaryImage }}"
                />
                <div class="font-size-20 fw-bold font-heading text-black text-uppercase">
                  {{ product.PortalProduct.DisplayName }}
                </div>
                <div class="text-primary font-size-25 fw-bold font-heading">
                  {{ product.PortalProduct.MerchantPrice / 100 | FortressCurrencyPipe }}
                </div>
                <div class="font-size-12 mt-2">
                  {{ 'membership.include' | translate }}
                </div>
                <div class="membership-description">
                  {{ product.PortalProduct.Description }}
                </div>
                <button class="btn border-0 choose-btn" (click)="childProductChange(product.PortalProduct.ProductId)">
                  {{ 'choose.membership.option' | translate }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>

        <!--Review Payment-->
        <ng-container *ngIf="currentStep == 1 && !membershipModalVisible">
          <div class="review-panel p-lg-0 ng-star-inserted">
            <div class="row review-panel-row">
              <div class="col-lg-7">
                <h4 class="font-size-20 mb-3">
                  {{ 'membership.upgrade.review.title' | translate }}
                </h4>
                <p class="font-size-14 fw-bold mb-2">
                  {{ 'kids.membership.upgrade.review.description' | translate }}
                </p>
                <hr class="border-info w-100 hr-items mt-1" />
                <div>
                  <div class="text-black my-2">
                    <div *ngFor="let child of childUpgrades">
                      <ng-container *ngIf="child.Product.ProductId > 0">
                        <div class="row my-1">
                          <div class="col-12 font-size-14">
                            <span class="fw-bold text-primary">{{ child.FirstName }} {{ child.LastName }}</span>
                            &nbsp;
                            <span class="font-size-12">{{ child.Product.DisplayName }}</span>
                          </div>
                          <div class="col-12 font-size-12">
                            <span class="fw-bold">{{ 'kids.membership.upgrade.product.cost.label' | translate }}</span>
                            <span class="ms-2">{{ child.Product.MerchantPrice / 100 | FortressCurrencyPipe }}</span>
                          </div>
                        </div>
                        <hr class="border-info w-100 hr-items" />
                      </ng-container>
                    </div>
                  </div>
                </div>
                <button class="btn text-primary fw-bold d-none border-0 d-lg-block ps-0" (click)="showPrevious(0)">
                  <span class="font-size-14 text-error">{{ 'upgrade.membership.review.cancel' | translate }}</span>
                </button>
              </div>

              <!-- Right Side -->
              <div [ngClass]="{ 'd-none': editingBillingAddress || editingShippingAddress }" class="col-lg-5">
                <div class="position-relative rounded border p-3 mb-4">
                  <div class="address-header d-flex mb-3 align-items-center">
                    <h6 class="address-title text-uppercase font-size-20 mb-0">
                      {{ 'upgrade.children.billing.title' | translate }}
                    </h6>
                    <a class="cursor-pointer ms-auto" (click)="editBillingAddress()">
                      <span class="font-size-14 text-primary fw-bold">{{ 'upgrade.membership.review.edit' | translate }}</span>
                    </a>
                  </div>
                  <div class="mb-0 font-size-14">
                    {{ billingAddress.Street }}, {{ billingAddress.Town }}, {{ billingAddress.County }},
                    {{ billingAddress.Postcode }}, {{ billingAddress.Country }}
                  </div>
                </div>
                <div class="position-relative border rounded p-3">
                  <div class="address-header d-flex mb-3 align-items-center">
                    <h6 class="address-title text-uppercase font-size-20 mb-0">
                      {{ 'upgrade.children.shipping.title' | translate }}
                    </h6>
                    <a class="cursor-pointer ms-auto" (click)="editShippingAddress()">
                      <span class="font-size-14 text-primary fw-bold">{{ 'upgrade.membership.review.edit' | translate }}</span>
                    </a>
                  </div>
                  <div class="mb-0 font-size-14">
                    {{ shippingAddress.Street }}, {{ shippingAddress.Town }}, {{ shippingAddress.County }},
                    {{ shippingAddress.Postcode }}, {{ shippingAddress.Country }}
                  </div>
                </div>
                <!-- Giftcode input -->
                <div class="form-floating input-group rounded my-4 mb-3">
                  <input
                    type="text"
                    class="form-control border gift-code-input font-size-14"
                    [(ngModel)]="giftCodeInput"
                    (blur)="detectGiftCodeInput()"
                    aria-describedby="gift-card"
                  />
                  <label>{{ 'membership.upgrade.apply.gift' | translate }}</label>
                  <button
                    class="btn btn-info text-white heading-text-one gift-code-input font-size-14 bg-primary px-3"
                    type="button"
                    (click)="applyGiftCode()"
                    [disabled]="!giftCodeInput"
                    id="gift-card"
                  >
                    {{ 'kids.membership.upgrade.gift.code' | translate }}
                  </button>
                </div>
                <p
                  class="mb-3 font-size-14"
                  [innerHtml]="'kids.membership.upgrade.gift.desc' | translate | markdownTranslate"
                ></p>

                <div class="rounded border p-3 my-2">
                  <h6 class="mb-3 font-size-20 text-black address-title">
                    {{ 'kids.membership.upgrade.summary.label' | translate }}
                  </h6>
                  <div class="row mb-2">
                    <div class="col-9 font-size-14">
                      {{ 'child.upgrade.checkout.items.label' | translate : { fgbdefault: 'Items' } }}
                    </div>
                    <div class="col-3 font-size-14 text-end">{{ totalAmount / 100 | FortressCurrencyPipe }}</div>
                  </div>
                  <ng-container *ngIf="totalTax > 0">
                    <div class="row mb-2">
                      <div class="col-9 font-size-14">
                        {{ 'child.upgrade.checkout.tax.label' | translate : { fgbdefault: 'Tax' } }}
                      </div>
                      <div class="col-3 font-size-14 text-end">{{ totalTax / 100 | FortressCurrencyPipe }}</div>
                    </div>
                  </ng-container>
                  <div class="row mb-2" *ngIf="totalShipping">
                    <div class="col-9 font-size-14">
                      {{ 'child.upgrade.checkout.shipping.label' | translate : { fgbdefault: 'Shipping' } }}
                    </div>
                    <div class="col-3 font-size-14 text-end">{{ totalShipping / 100 | FortressCurrencyPipe }}</div>
                  </div>
                  <div class="row mb-2" *ngIf="appliedGiftCodes && appliedGiftCodes.length > 0">
                    <div class="col-12 font-size-12 fw-bold">Discount Code(s):</div>
                    <ng-container *ngFor="let giftCode of appliedGiftCodes">
                      <div class="giftcode">
                        <button class="delete-code-btn" (click)="removeGiftCode(giftCode.Code)">
                          <i class="material-icons-outlined">cancel</i>
                        </button>
                        <span class="code">{{ giftCode.Code }}</span>

                        <div class="discount-value">
                          <span *ngIf="giftCode.EntitlementValueType == 0"
                            >- {{ giftCode.EntitlementValue / 100 | FortressCurrencyPipe }}</span
                          >
                          <span *ngIf="giftCode.EntitlementValueType == 1">- {{ giftCode.EntitlementValue }}%</span>
                          <span *ngIf="giftCode.EntitlementValueType == 2">FREE</span>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                  <hr class="my-3 bg-muted" />
                  <div class="row fw-bold font-size-14 mt-2">
                    <div class="col-8">{{ 'kids.membership.upgrade.payment.details.total' | translate }}</div>
                    <div class="col-4 text-end">
                      {{ totalBasketAmount / 100 | FortressCurrencyPipe }}
                    </div>
                  </div>
                </div>
                <fgbcl-errors></fgbcl-errors>
                <!--Pay now button-->
                <button
                  class="btn btn-success fw-bold mt-4 w-100 font-size-14 d-lg-block d-none text-white"
                  (click)="showModalPayment(paymentDetails)"
                >
                  {{ 'upgrade.child.proceed.payment' | translate }}
                </button>
              </div>

              <!-- EDIT BILLING ADDRESS FORM -->
              <ng-container *ngIf="editingBillingAddress">
                <div class="col-lg-5">
                  <div class="position-relative rounded border p-3">
                    <div class="address-header d-flex mb-3 align-items-center">
                      <h6 class="address-title text-uppercase font-size-20 mb-0">
                        {{ 'upgrade.children.billing.title' | translate }}
                      </h6>
                      <a
                        class="cursor-pointer ms-auto font-size-14 text-danger fw-bold"
                        (click)="clearAddressForm(billingAddressForm)"
                        >{{ 'upgrade.children.form.clear' | translate }}</a
                      >
                    </div>
                    <form [formGroup]="billingAddressForm" class="font-size-12">
                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="Street"
                          placeholder="Street"
                          name="Street"
                          formControlName="Street"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedBillingAddress &&
                              !!billingAddressForm.controls.Street.errors &&
                              billingAddressForm.controls.Street.touched,
                          }"
                          required
                        />
                        <label for="Street">
                          {{ 'upgrade.children.form.street' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{
                            'upgrade.children.form.street.invalid' | translate : { fgbdefault: 'Please enter a valid street.' }
                          }}
                        </div>
                      </div>

                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="Town"
                          name="Town"
                          placeholder="Town"
                          formControlName="Town"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedBillingAddress &&
                              !!billingAddressForm.controls.Town.errors &&
                              billingAddressForm.controls.Town.touched,
                          }"
                          required
                        />
                        <label for="Town">
                          {{ 'upgrade.children.form.city' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{ 'upgrade.children.form.city.invalid' | translate : { fgbdefault: 'Please enter a valid city.' } }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <fgbcl-select-country
                          [label]="'fgbcl.registration.payment.form.country.label' | translate : { fgbdefault: 'Country' }"
                          formControlName="Country"
                          (countryChange)="onCountryChange($event)"
                        ></fgbcl-select-country>
                        <div
                          class="error-message"
                          *ngIf="
                            hasSubmittedBillingAddress &&
                            !!billingAddressForm.controls.Country.errors &&
                            billingAddressForm.controls.Country.touched
                          "
                        >
                          {{
                            'upgrade.children.form.country.invalid' | translate : { fgbdefault: 'Please enter a valid country.' }
                          }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <fgbcl-select-region
                          formControlName="County"
                          [label]="'fgbcl.registration.payment.form.state.label' | translate : { fgbdefault: 'State' }"
                          [options]="regions"
                        ></fgbcl-select-region>
                        <div
                          class="error-message"
                          *ngIf="
                            hasSubmittedBillingAddress &&
                            !!billingAddressForm.controls.County.errors &&
                            billingAddressForm.controls.County.touched
                          "
                        >
                          {{ 'upgrade.children.form.county.invalid' | translate : { fgbdefault: 'Please enter a valid state.' } }}
                        </div>
                      </div>

                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="Postcode"
                          name="Postcode"
                          placeholder="Postcode"
                          formControlName="Postcode"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedBillingAddress &&
                              !!billingAddressForm.controls.Postcode.errors &&
                              billingAddressForm.controls.Postcode.touched,
                          }"
                          required
                        />
                        <label for="Postcode">
                          {{ 'upgrade.children.form.zip' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{
                            'upgrade.children.form.postcode.invalid'
                              | translate : { fgbdefault: 'Please enter a valid zip code.' }
                          }}
                        </div>
                      </div>

                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="phone"
                          name="phone"
                          placeholder="Home Number"
                          formControlName="HomeNumber"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedBillingAddress &&
                              !!billingAddressForm.controls.HomeNumber.errors &&
                              billingAddressForm.controls.HomeNumber.touched,
                          }"
                          required
                        />
                        <label for="phone">
                          {{ 'upgrade.children.form.homenumber' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{
                            'upgrade.children.form.homenumber.invalid'
                              | translate : { fgbdefault: 'Please enter a valid phone number.' }
                          }}
                        </div>
                      </div>
                    </form>
                    <div class="action-wrapper d-flex justify-content-between mt-3 font-size-14">
                      <button class="btn text-danger fw-bold btn-edit" (click)="cancelAndRebuildForm('billing')">
                        {{ 'child.upgrade.checkout.form.cancel.button' | translate : { fgbdefault: 'Cancel' } }}
                      </button>
                      <button class="btn btn-success fw-bold btn-edit text-white" (click)="updateBillingAddress()">
                        {{ 'child.upgrade.checkout.form.save.button' | translate : { fgbdefault: 'Save' } }}
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="editingShippingAddress">
                <div class="col-lg-5">
                  <div class="position-relative rounded border p-3">
                    <div class="address-header d-flex mb-3 align-items-center">
                      <h6 class="address-title text-uppercase font-size-20 mb-0">
                        {{ 'upgrade.children.shipping.title' | translate }}
                      </h6>
                      <a
                        class="cursor-pointer ms-auto font-size-14 text-danger fw-bold"
                        (click)="clearAddressForm(shippingAddressForm)"
                        >{{ 'upgrade.children.form.clear' | translate }}</a
                      >
                    </div>
                    <form [formGroup]="shippingAddressForm" class="font-size-12">
                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="Street"
                          placeholder="Street"
                          name="Street"
                          formControlName="Street"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedShippingAddress &&
                              !!shippingAddressForm.controls.Street.errors &&
                              shippingAddressForm.controls.Street.touched,
                          }"
                          required
                        />
                        <label for="Street">
                          {{ 'upgrade.children.form.street' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{
                            'upgrade.children.form.street.invalid' | translate : { fgbdefault: 'Please enter a valid street.' }
                          }}
                        </div>
                      </div>

                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="Town"
                          name="Town"
                          placeholder="Town"
                          formControlName="Town"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedShippingAddress &&
                              !!shippingAddressForm.controls.Town.errors &&
                              shippingAddressForm.controls.Town.touched,
                          }"
                          required
                        />
                        <label for="Town">
                          {{ 'upgrade.children.form.city' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{ 'upgrade.children.form.city.invalid' | translate : { fgbdefault: 'Please enter a valid city.' } }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <fgbcl-select-country
                          [label]="'fgbcl.registration.payment.form.country.label' | translate : { fgbdefault: 'Country' }"
                          formControlName="Country"
                          (countryChange)="onCountryChange($event)"
                        ></fgbcl-select-country>
                        <div
                          class="error-message"
                          *ngIf="
                            hasSubmittedShippingAddress &&
                            !!shippingAddressForm.controls.Country.errors &&
                            shippingAddressForm.controls.Country.touched
                          "
                        >
                          {{
                            'upgrade.children.form.country.invalid' | translate : { fgbdefault: 'Please enter a valid country.' }
                          }}
                        </div>
                      </div>
                      <div class="mb-3">
                        <fgbcl-select-region
                          formControlName="County"
                          [label]="'fgbcl.registration.payment.form.state.label' | translate : { fgbdefault: 'State' }"
                          [options]="regions"
                        ></fgbcl-select-region>
                        <div
                          class="error-message"
                          *ngIf="
                            hasSubmittedShippingAddress &&
                            !!shippingAddressForm.controls.County.errors &&
                            shippingAddressForm.controls.County.touched
                          "
                        >
                          {{ 'upgrade.children.form.county.invalid' | translate : { fgbdefault: 'Please enter a valid state.' } }}
                        </div>
                      </div>

                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="Postcode"
                          name="Postcode"
                          placeholder="Postcode"
                          formControlName="Postcode"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedShippingAddress &&
                              !!shippingAddressForm.controls.Postcode.errors &&
                              shippingAddressForm.controls.Postcode.touched,
                          }"
                          required
                        />
                        <label for="Postcode">
                          {{ 'upgrade.children.form.zip' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{
                            'upgrade.children.form.postcode.invalid'
                              | translate : { fgbdefault: 'Please enter a valid zip code.' }
                          }}
                        </div>
                      </div>
                      <div class="form-floating mb-3">
                        <input
                          type="text"
                          class="form-control"
                          id="phone"
                          name="phone"
                          placeholder="Phone Number"
                          formControlName="HomeNumber"
                          [ngClass]="{
                            'is-invalid':
                              hasSubmittedShippingAddress &&
                              !!shippingAddressForm.controls.HomeNumber.errors &&
                              shippingAddressForm.controls.HomeNumber.touched,
                          }"
                          required
                        />
                        <label for="phone">
                          {{ 'upgrade.children.form.homenumber' | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <div class="invalid-feedback">
                          {{
                            'upgrade.children.form.homenumber.invalid'
                              | translate : { fgbdefault: 'Please enter a valid phone number.' }
                          }}
                        </div>
                      </div>
                    </form>
                    <div class="action-wrapper d-flex justify-content-between mt-3 font-size-14">
                      <button class="btn text-danger fw-bold btn-edit" (click)="cancelAndRebuildForm('shipping')">
                        {{ 'child.upgrade.checkout.form.cancel.button' | translate : { fgbdefault: 'Cancel' } }}
                      </button>
                      <button class="btn btn-success fw-bold btn-edit text-white" (click)="updateShippingAddress()">
                        {{ 'child.upgrade.checkout.form.save.button' | translate : { fgbdefault: 'Save' } }}
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="row px-2" *ngIf="!editingBillingAddress && !editingShippingAddress">
            <div class="button-container px-4 mb-lg-0 d-flex flex-column d-lg-none mt-2">
              <!-- Next Button -->
              <button (click)="showNext(2)" class="btn btn-success nav-button fw-bold mb-lg-0 text-white w-100">
                {{ 'upgrade.child.proceed.payment' | translate }}
              </button>

              <!-- Previous Button -->
              <button (click)="showPrevious(0)" class="btn border-none text-error nav-button fw-bold mb-0 w-100 mt-3">
                {{ 'upgrade.membership.review.cancel' | translate }}
              </button>
            </div>
          </div>
        </ng-container>

        <!--Payment Process-->
        <ng-container *ngIf="currentStep == 2">
          <ng-container *ngTemplateOutlet="paymentDetails"></ng-container>
        </ng-container>

        <ng-container *ngIf="orderCompleted">
          <div class="d-flex flex-row h-100 completed-screen">
            <div class="d-flex flex-column justify-content-between px-3">
              <div class="d-flex flex-column mb-3">
                <div class="d-flex justify-content-center align-items-center my-2 d-lg-none">
                  <img alt="" src="assets/images/kidnationnewlogo.svg" class="kid-logo" />
                </div>
                <h2 class="text-start text-success my-lg-3 mb-4 font-size-18">{{ 'purchase.success.title' | translate }}</h2>
                <div
                  class="font-size-14 success-desc"
                  [innerHTML]="'purchase.success.description' | translate | markdownTranslate"
                ></div>
                <button class="w-fit-content w-100-sm px-6 btn btn-primary font-size-14 fw-bold" (click)="CloseModal()">
                  {{ 'kids.membership.upgrade.button.completed' | translate }}
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #paymentDetails let-modal>
  <div class="d-flex flex-column w-100 w-lg-50">
    <div class="border-bottom d-flex justify-content-between">
      <div class="payment-header">
        <h5 class="text-start m-0 font-size-14 font-default fw-bold text-capitalize">
          {{ 'kids.membership.upgrade.payment.details.title' | translate }}
        </h5>
        <ng-container *ifScreenSize="screenType.Desktop">
          <span class="icon material-icons cancel text-info cursor-pointer" aria-hidden="true" (click)="modal.close()"
            >close_small</span
          >
        </ng-container>
        <ng-container *ifScreenSize="screenType.Mobile">
          <span class="icon material-icons cancel text-info cursor-pointer" aria-hidden="true" (click)="showPrevious(1)"
            >close_small</span
          >
        </ng-container>
      </div>
    </div>
    <div class="modal-body">
      <!-- Summary -->
      <div class="payment-form">
        <!-- Payment Provider Form -->
        <div *ngIf="loadingPaymentForm">
          <fgbcl-loading></fgbcl-loading>
        </div>
        <div id="paymentDiv" class="mb-4"></div>
      </div>
    </div>
    <div class="button-container payment-action-wrapper mb-lg-0 d-flex align-items-center justify-content-end">
      <!-- Previous Button -->
      <ng-container *ifScreenSize="screenType.Desktop">
        <button (click)="modal.close()" class="btn text-danger nav-button fw-bold mb-0">
          {{ 'registration.payment.modal.cancel.button' | translate : { fgbdefault: 'Cancel' } }}
        </button>
      </ng-container>
      <ng-container *ifScreenSize="screenType.Mobile">
        <button (click)="showPrevious(1)" class="btn text-danger nav-button fw-bold mb-0">
          {{ 'registration.payment.modal.cancel.button' | translate : { fgbdefault: 'Cancel' } }}
        </button>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #unappliedGiftCodeModal let-modal>
  <div class="transfer-status-modal">
    <div class="modal-header">
      <h6 class="fw-bold">
        {{
          'fgbcl.registration.payment.modal.giftcode.not.applied.title'
            | translate : { fgbdefault: 'The following gift code has not been applied' }
        }}
      </h6>
    </div>
    <div class="content p-3">
      <p class="unapplied-code-instruction font-size-14">
        {{
          'fgbcl.registration.payment.modal.giftcode.not.applied.instruction'
            | translate : { fgbdefault: 'Please remove or apply this code' }
        }}
      </p>
      <p class="fw-bold text-center text-success mt-4 mb-0">
        {{ giftCodeInput }}
      </p>
    </div>
    <div class="modal-footer justify-content-lg-end justify-content-between">
      <button class="btn text-danger fw-bold" (click)="modal.dismiss('close'); removeUnappliedGiftCode()">
        {{ 'fgbcl.registration.payment.modal.remove.button' | translate : { fgbdefault: 'Remove Code' } }}
      </button>
      <button class="btn btn-success fw-bold" (click)="modal.dismiss('close'); applyGiftCode()">
        {{ 'fgbcl.registration.payment.modal.apply.button' | translate : { fgbdefault: 'Apply Code' } }}
      </button>
    </div>
  </div>
</ng-template>
